import {serializeError} from './serializeError'
import type {LogAttributes, Logger, LogLevel, LogMethod, LogSink} from './types'

const createMethod =
  (sink: LogSink, level: LogLevel): LogMethod =>
  (message, context, error) => {
    const attributes: LogAttributes = error === undefined ? {...context} : {...context, error: serializeError(error)}

    sink(level, message, attributes)
  }

export const createLogger = (sink: LogSink): Logger => ({
  debug: createMethod(sink, 'debug'),
  info: createMethod(sink, 'info'),
  warn: createMethod(sink, 'warn'),
  error: createMethod(sink, 'error'),
})
